export default "__VITE_ASSET__Jlnj8Lfy__"